var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.48627 22.5696L0.51241 14.7524C0.117321 14.4056 -0.371539 13.2685 0.439756 12.3435C1.25105 11.4186 2.44235 11.7406 2.83535 12.0858L9.00911 17.4637L20.734 2.77942C21.0709 2.3534 22.138 1.49226 23.3049 2.41343C24.4718 3.3346 23.9002 4.56584 23.5511 5.0072L9.48627 22.5696Z","fill":"currentColor"}));
}

Check.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Check;

Check.default = Check;
